/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:2fe42957-c401-49d1-b6de-fe9d8ed9bc9c",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_vKd8IlDwb",
    "aws_user_pools_web_client_id": "6d1rclnljg9602tc8cv25jv9ai",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://bfsbqrbcvbbrvndez6u6qqwxri.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://6kh0t3gmuc.execute-api.eu-central-1.amazonaws.com/master",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "elevid-documents145116-master",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
